export const formatPhone = (phone) => {
  const reg = /([\d]+)(\+)([\d]+)/g;

  if (!phone) return '-';
  return phone.replace(reg, `+$1 $3`);
};

/**
 * 국가코드 제외
 * @param phone{String} 전화번호
 * @return {*|string}
 */
export const extractPhone = (phone) => {
  if (!phone) return '';
  if (!phone.includes('+')) return phone;
  return phone.split('+')[1];
};
